import { Outlet } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/ui.store'
import { useAuthStore } from '@/stores/auth.store'
import { Sidebar, MobileSidebar } from '@/components/layout/Sidebar'
import { Topbar } from '@/components/layout/Topbar'
import { SoftphoneProvider } from '@/components/layout/SoftphoneProvider'

// Carga diferida a propósito: arrastra SIP.js (stack WebRTC completo). Solo
// debe bajar ese peso el navegador de un agente que de verdad tiene
// extensión asignada — para todos los demás (hoy, el 100%), ni se pide.
const SoftphoneBar = lazy(() =>
  import('@/components/layout/SoftphoneBar').then((m) => ({ default: m.SoftphoneBar })),
)

export function AppShell() {
  const hasSipExtension = useAuthStore((s) => !!s.profile?.sip_extension)
  const collapsed = useUIStore((s) => s.sidebarCollapsed)

  return (
    <SoftphoneProvider>
      <div className="min-h-screen bg-[var(--bg-base)] text-[var(--text-primary)]">
        <a href="#main-content" className="skip-link">
          Saltar al contenido principal
        </a>
        <Sidebar />
        <MobileSidebar />
        <Topbar />
        <main
          id="main-content"
          tabIndex={-1}
          className={cn(
            'min-h-screen pt-[56px]',
            collapsed ? 'md:pl-[56px]' : 'md:pl-[230px]',
            'transition-[padding-left] duration-200 ease-out'
          )}
        >
          <div className="h-full">
            <Outlet />
          </div>
        </main>
        {hasSipExtension && (
          <Suspense fallback={null}>
            <SoftphoneBar />
          </Suspense>
        )}
      </div>
    </SoftphoneProvider>
  )
}
